import { getActiveAbTestConfig, getPatternByPercentage } from '../config/abTest/abTestConfig'
import { getAbValueFromCookie } from '../utils/abTestUtils'

interface UseAbTestIssuePatternProps {
    abValue?: number
    currentPath?: string
}

/**
 * 指定した施策番号のABテストが現在のパスで有効なときだけ、その施策のパターンを返す。
 *
 * 例: DEV-3391 では料理ジャンルを /signup と /job_seekers/{token}/edit で共有しており、
 * useAbTest だと有効な施策があるパスでは施策を問わず 'B' が返るため、
 * 別施策のテスト中のパスでB表示が誤発火する。複数パスで共有する部品の分岐はこちらを使う。
 */
export const useAbTestIssuePattern = (
    issueNumber: string,
    {
        abValue = getAbValueFromCookie(),
        currentPath = typeof window !== 'undefined'
            ? window.location.pathname + window.location.search
            : '/',
    }: UseAbTestIssuePatternProps = {}
): 'A' | 'B' | 'C' | 'D' => {
    const activeConfig = getActiveAbTestConfig(currentPath)
    if (activeConfig?.issueNumber !== issueNumber) return 'A'

    return getPatternByPercentage(abValue, activeConfig.patterns)
}
